import Vue from 'vue';
import axios from 'axios';

window.Vue = Vue;
window.axios = axios;
Vue.prototype.$http = window.axios;

window.axios.defaults.headers.common = {
  'X-CSRF-Token': document.querySelector('[name="csrf-token"]').getAttribute('content'),
  'X-REQUESTED-WITH': 'XMLHttpRequest'
};